import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";

export default (theme: APTheme) => createStyles({
  tableContainer: {
    '& > table': {
      border: '1px solid rgba(224, 224, 224, 1)',
      borderBottom: 'none'
    },
    '& .MuiTableHead-root': {
      backgroundColor: '#FFF'
    }
  },
  pagination: {
    marginTop: '3rem',
    display: 'flex',
    justifyContent: 'center',
    '& .MuiPaginationItem-page': {
      borderRadius: 3,
      color: '#4A4A4A',
      fontSize: 16,
      fontWeight: 500,
      '&.Mui-selected': {
        backgroundColor: '#2D91E9', // TODO - Get hex colour codes from constant style variables
        color: '#FFF' // TODO - Get hex colour codes from constant style variables
      },
    },
    '& .MuiPaginationItem-icon': {
      fontSize: '2rem'
    }
  },
  tradePagination: {
    justifyContent: 'left',
    marginTop: '1.25rem'
  },
  tableCell: {
    fontSize: 16,
    padding: 20,
    '&:first-child': {
      fontWeight: 500
    },
    '&:last-child > span': {
      justifyContent: 'flex-end'
    },
    '&.isResponsive': {
      width: 'auto',
      padding: '0',
      position: 'relative',
      fontSize: 14,
      display: 'grid',
      gridTemplateColumns: '10em auto',
      justifyItems: 'stretch',
      border: 'none',
      marginBottom: 5,
      '&:before': {
        content: 'attr(data-label)',
        fontWeight: 500,
      },
      '&:last-child': {
        marginBottom: 0,
        '& > span': {
          justifyContent: 'flex-start',
        },
      }
    }
  },
  tableDateCell:{
    '&:first-child': {
    fontWeight: 400
    }
  },
  tableCellSmallSpan: {
    color: '#a4a4a4',
    fontSize: 14,
    fontWeight: 500
  },
  smallTableCell: {
    '&:last-child > span': {
      justifyContent: 'flex-start'
    }
  },
  tableRowHeader: {
    '&.isResponsive': {
      display: 'none',
    }
  },
  tableHeaderCell: {
    color: '#A4A4A4',
    fontSize: 15,
    fontWeight: 'normal',
    padding: 20,
    textTransform: 'uppercase',
    backgroundColor: '#fff',
    whiteSpace: 'nowrap',
    '&:last-child': {
      textAlign: 'right',
    },
    '&:first-child': {
      //borderLeft: '1px solid rgba(224, 224, 224, 1)'
    },
    '&.isResponsive': {
      fontSize: 13,
      padding: '17px 20px',
    }
  },
  tableDropdownCell: {
    color: '#4A4A4A',
    lineHeight: '42px',
    fontSize: 15,
    fontWeight: 'normal',
    padding: '20px 30px 20px 20px',
    backgroundColor: '#fff',
    whiteSpace: 'nowrap',
    '&:last-child': {
      textAlign: 'right',
      justifyContent: 'flex-end'
    },
    '&.isResponsive': {
      display: 'block',
      width: 'auto',
      padding: '1.25em',
      paddingTop: 0,
      position: 'relative',
      textAlign: 'left',
      justifyContent: 'flex-start'
    }
  },
  showLabel: {
    marginRight: 10,
    padding: 10,
    fontSize: 16,
    fontWeight: 500,
    paddingLeft: 0,
    '@media(max-width: 570px)': {
      display: 'none',
    },
  },
  tableHeadingCell: {
    color: '#4A4A4A', // TODO - Get hex colour codes from constant style variables
    fontSize: 18,
    fontWeight: 500,
    padding: '2.25rem 20px',
    backgroundColor: '#fff', // TODO - Get hex colour codes from constant style variables
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    '&.isResponsive': {
      display: 'block',
      width: 'auto',
      borderBottom: 'none',
      padding: '1.25em',
      position: 'relative',
      textAlign: 'left',
      justifyContent: 'flex-start'
    }
  },
  summaryTableHeaderHalf: {
    '&.isResponsive': {
      display: 'inline-flex',
      width: '50%',
      padding: 0
    }
  },
  summaryTableHeaderFull: {
    '&.isResponsive': {
      display: 'inline-flex',
      padding: 0
    }
  },
  summaryTableTransactionText: {
    '&.isResponsive': {
      display: 'inline-flex',
      width: '50%',
      padding: 0,
      justifyContent: 'flex-end'
    }
  },
  searchTableHeadingCell: {
    padding: '18px 30px',
    lineHeight: '25px'
  },
  summaryHeaderTextSpan: {
    padding: 0,
    paddingLeft: 10,
    fontSize: 18,
    '&.isResponsive': {
      padding: '1.25em'
    }
  },
  tableHeadingCellSpan: {
    color: '#A4A4A4', // TODO - Get hex colour codes from constant style variables
    fontSize: 16,
    fontWeight: 400
  },
  searchDataTableHeadingCellSpan: {
    fontSize: 18,
    fontWeight: 700
  },
  tableHeadingCellText: {
    textAlign: 'right',
    '& span': {
      fontSize: 14,
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 1.29,
    }
  },
  smallTableHeaderCell: {
    '&:last-child': {
      textAlign: 'left',
    },
  },
  smallSearchTableHeaderCell: {
    padding: 22,
    paddingBottom: 21,
    lineHeight: '18px',
    '&:first-child': {
      paddingLeft: 30
    },
    '&:last-child': {
      textAlign: 'left',
      paddingRight: 30
    }
  },
  smallSearchTableCell: {
    padding: 22,
    paddingBottom: 21,
    lineHeight: '18px',
    '&:first-child': {
      paddingLeft: 30
    },
    '&:last-child': {
      textAlign: 'right',
      paddingRight: 30,
      '@media(max-width: 990px)': {
        textAlign: 'left'
      }
    },
    '&:last-child > span': {
      justifyContent: 'flex-start'
    },
    '&.isResponsive': {
      paddingLeft: 0
    }
  },
  downloadButtonCell: {
    '&:last-child > span': {
      justifyContent: 'flex-end'
    }
  },
  tradeButtonCell: {
    padding: 20,
    paddingTop: 19
  },
  tradeTableOpen: {
    borderBottom: 'unset'
  },
  formSectionRadio: {
    color: '#4A4A4A',
    display: 'inline-block',
    flexDirection: 'row',
    float: 'right',
    '& .MuiSvgIcon-root': {
      fill: theme.palette.primary.main,
      fontSize: '2.6rem'
    },
    '& .MuiFormControlLabel-root:first-child': {
      marginRight: 16,
      marginLeft: 0
    },
    '& .MuiFormControlLabel-root:last-child': {
      marginLeft: 15,
      marginRight: 0
    },
    '& .MuiIconButton-root': {
      padding: "0px 10px 0px 0px !important",
      '& .APRadio-icon': {
        width: 20,
        height: 20
      }
    },
    '& .MuiTypography-body1': {
      lineHeight: '18px'
    },
    '&.isResponsive': {
      '@media(max-width: 620px)': {
        float: 'left',
        display: 'block',
        width: '100%'
      },
      '& .MuiFormControlLabel-root:last-child': {
        marginLeft: 11
      }
    }
  },
  evenTradeRow: {
    backgroundColor: '#ffffff'
  },
  tradeTableCell: {
    paddingBottom: 0,
    paddingTop: 0,
    '&.isOpen': {
      paddingBottom: 35
    }
  },
  blankDataTableCell: {
    height: 400,
    color: '#4A4A4A',
    fontSize: 18,
    fontWeight: 500,
    padding: '2.25rem 20px',
    backgroundColor: '#fff',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    '&.isResponsive': {
      display: 'block',
      width: 'auto',
      borderBottom: 'none',
      padding: '1.25em',
      position: 'relative',
      textAlign: 'left',
      justifyContent: 'flex-start'
    }
  },
  tableEmptyCell: {
    padding: 0
  },
  emptyDataIcon: {
    fontSize: 0,
    lineHeight: 0
  },
  emptyData: {
    backgroundColor: '#fff',
    textAlign: 'center'
  },
  emptyDataHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 5,
    '& > span': {
      display: 'block',
      fontSize: 26,
      fontWeight: 700,
      lineHeight: '34px',
      marginTop: 21
    },
    '& p': {
      width: 283,
      margin: 0,
      fontSize: 17,
      fontWeight: 450,
      lineHeight: '24px',
    }
  }
});
